import script from "./addFollowRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./addFollowRecord.vue?vue&type=script&setup=true&lang=js"

import "./addFollowRecord.vue?vue&type=style&index=0&id=6c21bb8b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c21bb8b"]])

export default __exports__